import React from "react";
import {AxiosResponse} from "axios";

export const clickElem = (elem: HTMLInputElement) => {
    var eventMouse = document.createEvent("MouseEvents");
    eventMouse.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    elem.dispatchEvent(eventMouse)
};

export const openFile = (func: ((contents: string, fileName: string) => void) | null, funcRaw: (file: File) => void) => {
    const readFile = function (ev: Event): any {
        const e: React.ChangeEvent<HTMLInputElement> = (ev as any) as React.ChangeEvent<HTMLInputElement>;
        if (!e.target.files)
            return;
        var file = e.target.files[0];
        if (!file)
            return;
        if (func != null) {
            var reader = new FileReader();
            reader.onload = function (e2) {
                var contents = e2.target?.result;
                if (contents && typeof (contents) === 'string')
                    func(contents, file.name);
                document.body.removeChild(fileInput)
            };
            reader.readAsText(file)
        }
        if (funcRaw != null)
            funcRaw(file);
        return 1;
    };
    const fileInput = document.createElement("input");
    fileInput.type = 'file';
    fileInput.style.display = 'none';
    fileInput.onchange = readFile;
    // fileInput.func=func
    document.body.appendChild(fileInput);
    clickElem(fileInput);
};

export const downloadLinkProcessor = (fileName: string, response: AxiosResponse | { data: File | null, headers?: any }) => {
    // create file link in browser's memory
    if (!response || !response.data)
        return;
    let href = null;
    try {
        if (typeof (response.data) === 'string') {
            href = URL.createObjectURL(new Blob([response.data as string]));
        } else if (response.data instanceof ArrayBuffer) {
            href = URL.createObjectURL(new Blob([response.data as ArrayBuffer]));
        } else {
            href = URL.createObjectURL(response.data);
        }
    } catch (e) {
        if (response.headers)
            href = URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}));
    }
    if (!href)
        return;
    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};

export const base64ToArrayBuffer = (content: string) => {
    if (!content)
        return null;
    const byteCharacters = atob(content);
    var bytes = new Uint8Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        bytes[i] = byteCharacters.charCodeAt(i);
    }
    return bytes.buffer;
};

export const arrayBufferToBase64 = (data: ArrayBuffer) => {
    if (!data)
        return null;
    let base64data = "";
    (new Uint8Array(data)).forEach(function (byte: number) {
        base64data += String.fromCharCode(byte);
    });
    return btoa(base64data);
};
